"use client"

import { ChevronIcon } from "@/app/icons/chevron"
import {
  Card,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  cn,
} from "@rarible_int/anaconda_ui_components"

export function ItemInfoCard(props: {
  children: React.ReactNode
  className?: string
}) {
  return <Card className={cn("p-4", props.className)}>{props.children}</Card>
}

export function ItemCollapsibleInfoCard(props: {
  header: React.ReactNode
  content: React.ReactNode
  className?: string
}) {
  return (
    <ItemInfoCard className={props.className}>
      <Collapsible
        className="group/collapsible flex flex-col gap-3"
        defaultOpen
      >
        <CollapsibleTrigger asChild>
          <div className="flex cursor-pointer items-center justify-between text-lg">
            {props.header}
            <ChevronIcon className="transition-transform group-data-[state=open]/collapsible:rotate-180" />
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent>{props.content}</CollapsibleContent>
      </Collapsible>
    </ItemInfoCard>
  )
}
